module.exports = __webpack_public_path__ + "img/red3.2f0fb16d.jpg";